import { emit } from '../eventBus';
import { isJsonResponse } from '../helpers/isJsonResponse';

export const availabiltyMiddleware = async (response: Response): Promise<Response> => {
  if (response.status === 423 && isJsonResponse(response)) {
    const {
      data: { reason },
    } = await response.clone().json();

    switch (reason) {
      case 'SERVICE_NOT_AVAILABLE':
        emit({
          action: 'update_services',
        });
        break;

      case 'FEATURE_NOT_AVAILABLE':
        emit({
          action: 'update_features',
        });
        break;

      default:
        break;
    }
  }

  return response;
};
